import Transport from './transport-fetch';

const dataService = {

	baseUrl: `${location.protocol}//${location.hostname}/api/filtersearch`,

	async getProviders(queryStringParams) {
		let queryStringParamsLength = queryStringParams.toString().length; 
		const url = queryStringParamsLength > 0 ? `${this.baseUrl}?${queryStringParams}`: `${this.baseUrl}` 
    return Transport.get(url);
  }
};

export default dataService;
